import { ModalService } from '@ibe.components/common/modal/modal.indra.service';
import { BehaviorSubject } from 'rxjs';
import scrollLock from 'scroll-lock';
import { AfterContentChecked } from '@angular/core';

export abstract class AbstractModalContentComponent implements AfterContentChecked {

	public TYPE: '' | 'dialog' | 'full' | 'large' | 'payment' = '';
	public CLOSABLE: true | false; // note: remvoed in post-sprint 8 client code delivery
	protected readonly dataSubscriber: BehaviorSubject<any[]>;
	destroy: Function;
	htmlElement = document.getElementsByTagName('html');

	protected constructor(protected modalService: ModalService) {
		this.dataSubscriber = new BehaviorSubject<any[]>(null);

		//this.htmlElement[0].classList.add('no-scroll');
		scrollLock.hide();
	}

	get data() { return this.dataSubscriber.getValue(); }
	set data(val) { this.dataSubscriber.next(val); }

	closeModal() {
		this.modalService.close();
		this.htmlElement[0].classList.remove('no-scroll');
		scrollLock.show();
		if (this.destroy) this.destroy();
	}

	ngAfterContentChecked() {
	/* 	if (!this.htmlElement[0].classList.contains('no-scroll')) {
			this.htmlElement[0].classList.add('no-scroll');
			scrollLock.hide();
		} */

	}

}
